<div class='wrapper text-center'>
  <h1 class='text-center'>Добро пожаловать в DocsAutomator!</h1>

  <div class='wrapper alert alert-success' role="alert">
    Для начала работы перейдите по вкладке "Шаблоны" или "Документы"
  </div>
  <app-help-hint info='Если вы здесь впервые, перейдите по вкладке Справка'></app-help-hint>
</div>
